import coverImg from "assets/images/v149/bg.webp"
import titleImg from "assets/images/v149/title.webp"

export const v149Config = {
  cover: { en: coverImg },
  title: { en: titleImg },
}
